import Vue from "vue";
import App from "./App.vue";
import VueGtm from '@gtm-support/vue2-gtm';
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import i18n from "./i18n";
import CountryFlag from "vue-country-flag";
import StackdriverErrorReporter from 'stackdriver-errors-js';

const errorHandler = new StackdriverErrorReporter();
errorHandler.start({
key: 'AIzaSyDabG9rSW5xT9Pp_QKNMIelgCe_uPXcH-Y',
projectId: 'dev-app-137723',
// The following optional arguments can also be provided:
   service: 'widgetsalonhub',
// Name of the service reporting the error, defaults to 'web'.
version: '1.1',
// Version identifier of the service reporting the error.
// reportUncaughtExceptions: false
// Set to false to prevent reporting unhandled exceptions.
// reportUnhandledPromiseRejections: false
// Set to false to prevent reporting unhandled promise rejections.
// disabled: true
// Set to true to not send error reports, this can be used when developing locally.
// context: {user: 'user1'}
// You can set the user later using setUser()
});


Vue.config.errorHandler = (err, vm, info) => {

  /**
   * 
   * captures the errors that are specific to Vue instances. 
   * It would not be able to capture the errors which are outside of Vue instances such as utils files, services etc.
   * 
   */

  // err: error trace
  // vm: component in which error occured
  // info: Vue specific error information such as lifecycle hooks, events etc.

  errorHandler.report(err, vm, info);
};

//Route error Handler Global
Vue.prototype.$errorHandler = errorHandler;

export const bus = new Vue();

Vue.config.productionTip = false;

Vue.use(VueGtm, {
  id: 'GTM-NW4DWPH', // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
  queryParams: {
    // Add URL query string when loading gtm.js with GTM ID (required when using custom environments)
    gtm_auth: 'OI3VqS81ayhfmcD3T_A5og',
    gtm_preview: 'env-2',
    gtm_cookies_win: 'x',
  },
  defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
  compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
  nonce: '2726c7f26c', // Will add `nonce` to the script tag
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: true, // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  ignoredViews: [], // Don't trigger events for specified router names (optional)
  trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
});

new Vue({
  router,
  store,
  vuetify,
  i18n,
  CountryFlag,

  render: h => h(App)
}).$mount("#app");


